import { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
    };

    const menuItems = [
        { name: 'Home', href: '/' },
        { name: 'Books', href: '/Books' },
        { name: 'Reports', href: '/Reports' },
        { name: 'Announcements', href: '/Announcements' },
        { name: 'News', href: '/News' },
        { name: 'MGs', href: '/MGs' },
        { name: 'SYLs', href: '/SYLs' },
        //{ name: 'About', href: '#' },
        //{ name: 'Contact', href: '#' }
    ];

    const socialPlatforms = [
        { name: 'facebook', url: '#' },
        { name: 'twitter', url: '#' },
        { name: 'instagram', url: '#' },
        { name: 'whatsapp', url: '#' }
    ];

    // Handle external link clicks (social media)
    const handleExternalClick = (e, url) => {
        e.preventDefault();
        // You can add your actual social media URLs here
        console.log('Navigating to:', url);
        // window.open(url, '_blank'); // Uncomment this for actual links
    };

    return (
        <header className="fixed w-full top-0 left-0 right-0 z-50 bg-gradient-to-r from-blue-900 to-purple-900 shadow-2xl">
            <div className="w-full px-4 sm:px-6 relative z-50">
                <div className="flex items-center justify-between h-16">
                    {/* Logo/Brand */}
                    <div className="flex items-center">
                        <Link to="/" className="flex items-center space-x-3">
                            <div className="relative">
                                <div className="w-10 h-10 bg-gradient-to-r from-amber-400 to-pink-500 rounded-full flex items-center justify-center">
                                    <span className="text-white font-bold text-xl">WC</span>
                                </div>
                                <div className="absolute -top-1 -right-1 w-4 h-4 bg-cyan-400 rounded-full animate-ping"></div>
                            </div>
                            <div className="hidden sm:block">
                                <span className="text-white font-bold text-xl tracking-wider">WC - AY</span>
                                <div className="text-cyan-300 text-xs">Youth Ministries</div>
                            </div>
                        </Link>
                    </div>

                    {/* Desktop Menu */}
                    <div className="hidden md:flex items-center space-x-1">
                        {menuItems.map((item, idx) => (
                            <Link
                                key={idx}
                                to={item.href}
                                className="text-white/90 hover:text-white px-3 py-2 rounded-lg hover:bg-white/10 transition-all duration-300 font-medium relative group text-sm lg:text-base lg:px-4"
                            >
                                {item.name}
                                <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-0 h-0.5 bg-gradient-to-r from-amber-400 to-pink-500 group-hover:w-4/5 transition-all duration-300"></span>
                            </Link>
                        ))}
                    </div>

                    {/* Desktop Social Icons */}
                    <div className="hidden md:flex items-center space-x-2 lg:space-x-3">
                        {socialPlatforms.map((platform, idx) => (
                            <button
                                key={idx}
                                onClick={(e) => handleExternalClick(e, platform.url)}
                                className="w-9 h-9 lg:w-10 lg:h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white/20 transform hover:scale-110 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-cyan-400"
                                aria-label={`Visit our ${platform.name} page`}
                            >
                                <i className={`fab fa-${platform.name} text-sm lg:text-base`}></i>
                            </button>
                        ))}
                    </div>

                    {/* Mobile Menu Button */}
                    <div className="md:hidden flex items-center space-x-3">
                        <div className="flex space-x-2">
                            {socialPlatforms.slice(0, 2).map((platform, idx) => (
                                <button
                                    key={idx}
                                    onClick={(e) => handleExternalClick(e, platform.url)}
                                    className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-cyan-400"
                                    aria-label={`Visit our ${platform.name} page`}
                                >
                                    <i className={`fab fa-${platform.name} text-sm`}></i>
                                </button>
                            ))}
                        </div>
                        <button
                            onClick={toggleMobileMenu}
                            className="text-white p-2 focus:outline-none focus:ring-2 focus:ring-white/50 rounded-lg"
                            aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
                            aria-expanded={isMobileMenuOpen}
                        >
                            {isMobileMenuOpen ? (
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            ) : (
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                </svg>
                            )}
                        </button>
                    </div>
                </div>

                {/* Mobile Menu */}
                <div className={`md:hidden absolute left-0 right-0 transition-all duration-300 ease-in-out ${
                    isMobileMenuOpen ? 'max-h-[500px] opacity-100 visible z-50' : 'max-h-0 opacity-0 invisible'
                }`}>
                    <div className="bg-gradient-to-r from-blue-800 to-purple-800 rounded-b-2xl shadow-xl mt-2 py-4 px-4 mx-4">
                        <div className="space-y-2">
                            {menuItems.map((item, idx) => (
                                <Link
                                    key={idx}
                                    to={item.href}
                                    onClick={closeMobileMenu}
                                    className="text-white hover:bg-white/10 block px-4 py-3 rounded-lg font-medium transition-all duration-300 text-base border-l-2 border-transparent hover:border-amber-400 hover:pl-5 active:bg-white/20"
                                >
                                    {item.name}
                                </Link>
                            ))}
                        </div>
                        
                        <div className="mt-6 pt-4 border-t border-white/20">
                            <div className="flex items-center justify-center space-x-6">
                                {socialPlatforms.map((platform, idx) => (
                                    <button
                                        key={idx}
                                        onClick={(e) => {
                                            handleExternalClick(e, platform.url);
                                            closeMobileMenu();
                                        }}
                                        className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white/20 transform hover:scale-110 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-cyan-400"
                                        aria-label={`Visit our ${platform.name} page`}
                                    >
                                        <i className={`fab fa-${platform.name}`}></i>
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Contact Info for Mobile */}
                        <div className="mt-6 text-center">
                            <p className="text-white/80 text-sm">Contact us:</p>
                            <a 
                                href="tel:+1234567890" 
                                className="text-amber-300 hover:text-amber-200 text-sm font-semibold inline-block mt-1"
                                onClick={closeMobileMenu}
                            >
                                +1 (234) 567-890
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Backdrop for mobile menu */}
            {isMobileMenuOpen && (
                <div 
                    className="fixed inset-0 bg-black/50 z-40 md:hidden"
                    onClick={closeMobileMenu}
                    aria-hidden="true"
                />
            )}
        </header>
    );
}

export default Header;